import { getApiCall, postApiCall, putApiCall } from "../utils/request";
import { returnErrors } from "./errorAction";
import {
    GET_SKILL_PODS, RESET_POD_DATA, CLOSE_ADD_SKILL_POD, ADD_SKILL_POD_MODAL, ADD_SKILL_POD, EDIT_SKILL_POD, GET_PODS_RESOURCES, GET_CONTENT_FOR_PODS,
    GET_NEXT_CONTENT_FOR_PODS, ADD_RESOURCE_TO_POD, REMOVE_RESOURCE_TO_POD, GET_RESOURCE_DETAILS, CLOSE_FEED_POPUP, CAPTURE_ANALYTIC,
    GET_LIKED_CONTENT, GET_LIKED_SUMMARY, GET_NEXT_LIKED_CONTENT, LIKES_LIKE, GET_SEARCH_LIKED_CONTENT, RESET_CONTENT_lOADING, REORDER_CONTENT, GET_SHARED_PODS
} from '../actionType/type';

export const getSkillPods = () => async (dispatch) => {
    try {
        const response = await getApiCall(`user/saved/pod`);
        dispatch({ type: GET_SKILL_PODS, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const addSkillPod = (item, edit) => async (dispatch) => {
    return dispatch({ type: ADD_SKILL_POD_MODAL, payload: { item, edit } });
};

export const handleModalClose = () => {
    return {
        type: CLOSE_ADD_SKILL_POD,
    };
};

export const resetPodData = () => {
    return {
        type: RESET_POD_DATA
    };
};

export const savedPod = (obj) => async (dispatch) => {
    let data = new FormData();
    data.append("title", obj.title);
    data.append("image", obj.image);
    try {
        const response = await postApiCall(`user/saved/pod`, data);
        if (response.data.success) {
            const data = response.data.data;
            dispatch({ type: ADD_SKILL_POD, payload: data });
            returnErrors(
                dispatch,
                'Skill pod is created',
                response.data !== undefined && response.status
            );
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status);
    }
}

export const updatePod = (obj) => async (dispatch) => {
    let data = new FormData();
    data.append("_id", obj._id);
    data.append("title", obj.title);
    data.append("image", obj.image);
    try {
        const response = await postApiCall(`user/saved/pod/edit`, data);
        if (response.data.success) {
            dispatch({ type: EDIT_SKILL_POD, payload: obj });
            returnErrors(
                dispatch,
                'Skill pod is updated',
                response.data !== undefined && response.status
            );
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status);
    }
};

export const getPodResources = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/learn/skills/pod?_id=${id}`);
        const data = response.data.data
        dispatch({ type: GET_PODS_RESOURCES, payload: data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const deletePod = (id) => async (dispatch) => {
    const obj = {
        _id: id
    }
    try {
        const response = await postApiCall(`user/saved/pod/delete`, obj);
        if (response.data.success) {
            returnErrors(
                dispatch,
                'Skill Pod is deleted',
                response.data !== undefined && response.status
            );
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status);
    }
};

export const getContentsForPod = (page, active) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/saved/recent?page=${page}&type=${active}`);
        dispatch({ type: GET_CONTENT_FOR_PODS, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getNextContentsForPod = (page, active) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/saved/recent?page=${page}&type=${active}`);
        dispatch({ type: GET_NEXT_CONTENT_FOR_PODS, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const addResourceToPod = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/saved/pod/resource`, obj);
        if (response.data.success) {
            returnErrors(
                dispatch,
                'Resource added to skill pod',
                200
            );
            dispatch({ type: ADD_RESOURCE_TO_POD, payload: obj._id });
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status);
    }
};

export const removeResourceFromPod = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/saved/pod/resources/delete`, obj);
        if (response.data.success) {
            dispatch({ type: REMOVE_RESOURCE_TO_POD, payload: obj._id });
            returnErrors(
                dispatch,
                'Resource is removed from skill pod',
                response?.status
            );
        } else {
            returnErrors(
                dispatch, response?.data?.message, response?.status
            );
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status);
    }
};

export const getContentDetails = (type, id) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/learn/resource?type=${type}&_id=${id}`);
        const data = response.data
        dispatch({ type: GET_RESOURCE_DETAILS, payload: data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status);
    }
}


export const closeFeedPopup = () => {
    return {
        type: CLOSE_FEED_POPUP,
    };
};

export const captureAnalytic = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall('user/learn/analytic', obj);
        dispatch({ type: CAPTURE_ANALYTIC, payload: obj });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status);
    }
}

export const getLikedContent = (type, page) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/saved/liked/resources?type=${type}&page=${page}`);
        const data = response.data.data
        dispatch({ type: GET_LIKED_CONTENT, payload: { data, type } });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getNextLikes = (type, page) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/saved/liked/resources?type=${type}&page=${page}`);
        const data = response.data.data
        dispatch({ type: GET_NEXT_LIKED_CONTENT, payload: { data, type } });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const likeFeed = (data) => async (dispatch) => {
    let likedId = {
        r_id: data._id,
        type: data.type,
        liked: data.liked
    }
    try {
        const response = await postApiCall('user/learn/resource/like', likedId);
        dispatch({ type: LIKES_LIKE, payload: likedId });
    }
    catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status);
    }
}

export const getLikedSummary = () => async (dispatch) => {
    try {
        const response = await getApiCall(`user/saved/liked`);
        dispatch({ type: GET_LIKED_SUMMARY, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getLikedContentSearch = (type, page, query) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/saved/liked/resources?type=${type}&page=${page}&query=${query}`);
        const data = response.data.data
        dispatch({ type: GET_SEARCH_LIKED_CONTENT, payload: { data, type } });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}


export const resetLoading = () => {
    return {
        type: RESET_CONTENT_lOADING,
    };
};

export const reorderContents = (result) => async (dispatch) => {
    return dispatch({ type: REORDER_CONTENT, payload: result });
};
export const reorderdContents = (id, sortArr) => async (dispatch) => {
    const obj = {
        _id: id,
        data: sortArr
    }
    try {
        const response = await putApiCall(`helper/reorder/pod`, obj);
        if (response.data.success) {
            dispatch({ type: "Reorder_Done" });
        }
        else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {

        returnErrors(dispatch, error.response?.data.message, error.response?.status);
    }
}

export const sharedPods = (page) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/shared/pods?page=${page}`);
        dispatch({ type: GET_SHARED_PODS, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}